import { logOut, setCredentials, setIsAuth, setIsAuthLoading } from '../../store/reducers/authSlice';
import { setIsError } from '../../store/reducers/notificationSlice';
import { setUser } from '../../store/reducers/userSlice';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useLazyGetUserViewQuery } from '../../api/UserApi/userView';
import { useEffect } from 'react';

export const useKundelikAuth = (accessToken) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [getUserInfo] = useLazyGetUserViewQuery();
    const refresh_token = JSON.parse(localStorage.getItem('jwt_refresh'));
    const username = JSON.parse(localStorage.getItem('user'))?.username;
    const activeRole = JSON.parse(localStorage.getItem('user'))?.activeRole;
    const getKundelikUser = async () => {
        const storedUser = JSON.parse(localStorage.getItem('user'));
        if (accessToken) {
            dispatch(setIsAuthLoading(true));
            dispatch(setCredentials(accessToken));
            if (username) {
                dispatch(setUser({ ...storedUser }));
                dispatch(setIsAuth(true));
            }
            const kundUser = await getUserInfo();
            if (kundUser.error) {
                console.error(kundUser.error);
                dispatch(logOut());
                dispatch(setIsError(t(`general.models.serverErrors.UView.${kundUser.error.data?.error_code}`, `${kundUser.error.data?.error_code}: ${kundUser.error.data?.message}`)));
            } else {
                const isUserHasRole = kundUser.data?.user.roles.includes(storedUser?.activeRole);
                const user = { ...kundUser.data.user };
                dispatch(setCredentials(accessToken));
                localStorage.setItem('user', JSON.stringify({ ...user, activeRole: activeRole || user.roles[0] }));
                dispatch(setIsAuth(true));
                dispatch(setUser({
                    ...user,
                    activeRole: isUserHasRole ? storedUser.activeRole : user.roles[0]
                }));
            }
            dispatch(setIsAuthLoading(false));
        } else if (!refresh_token && username) {
            window.location.assign(`http://91.147.93.80:30764/realms/mektep/protocol/openid-connect/auth?client_id=mektep&response_type=token&redirect_uri=https%3A%2F%2Ftest.okulyktar.kz%2F`);
        }
    };
    useEffect(() => {
        getKundelikUser();
    }, []);
};